import { Component, Input, OnInit, Output, EventEmitter, OnDestroy, OnChanges,SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as _ from 'lodash';

import { QuestionBase } from '../../../components/sample/model/question-base';
import { QuestionControlService } from '../../../components/sample/services/question-control.service';
import { CurBaseService } from '../../services/firebase/curbase.service';
import { first, tap, startWith, distinctUntilChanged, distinctUntilKeyChanged } from 'rxjs/operators';
import { QuestionService } from '../../../components/sample/services/question.service';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  providers: [ QuestionControlService ],
  styleUrls:['./dynamic-form.component.scss'],
})
export class DynamicFormComponent implements OnInit,OnDestroy, OnChanges {

  public preguntas: QuestionBase<any>[] | null = [];
  // @Input() questions: QuestionBase<any>[] | null = [];
  @Input() questions: QuestionBase<any>[] | null = [];
  @Input() assetInfo: any;
  form!: FormGroup;
  payLoad = '';
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  @Output() save: EventEmitter<any> = new EventEmitter();
  observables$: any[]=[];

  constructor(private qcs: QuestionControlService, private cb: CurBaseService, private quest: QuestionService) {}

  ngOnInit() {
    
    this.form = this.qcs.toFormGroup(this.questions as QuestionBase<any>[]);
    console.log('formdynamicForm', this.form,this.questions)
  
    for (const q of this.questions) {
      if(q.childLink && q.child){
        console.log('holataplocation',q)
        const obs$ = this.form.controls[q.key].valueChanges.pipe(startWith(this.form.controls[q.key].value),tap(x=>console.log('valordeltap', x))).subscribe(async x=>{
          console.log(x,'xvalue')
          if(!x){
            x ={ key:'',value:''}
          }
          const childLink =q.childLink
          const options:any = await this.cb.getCollectionWhereFB(childLink,'parentKey',x.key).pipe(first()).toPromise()
          const index = this.questions.findIndex(o => o.key === q.child);
    
          this.questions[index].options = options
          console.log('holataplocation1',x,this.questions,index)})
        this.observables$.push(obs$)

      }
      
    }

  }
  ngOnDestroy(){
    if(this.observables$.length){
      
    for (const element of this.observables$) {
      console.log('elementunsubscribe()',element);
      element.unsubscribe()
    }
    }
  }

  ngOnChanges(change:SimpleChanges){
    console.log('changedynamic',change)
    if(change.questions.currentValue){

    }
   
  console.log('on changes dynamic form',change)
  }

  onSubmit() {
    this.payLoad = JSON.stringify(this.form.getRawValue());
  }
  public submitForm(): void {
    console.log(this.form.value)
    this.form.markAllAsTouched();
   if(this.form.valid){
    const saveObj ={
      form: this.form.value,
      assetInfo: this.assetInfo
    } 
    this.save.emit(saveObj)
     if(this.assetInfo.key.length){
       if(this.assetInfo.model){
         console.log('a editar en', this.assetInfo)
         const formValue = this.form.value
        //  formValue.tipo = formValue.tipo.key
         formValue.type = formValue.type.key
         this.cb.actArrayDocFb(this.assetInfo['key'],this.assetInfo['route'],formValue,formValue.tipo.key)
    
       } else{

         this.cb.actDocFb(this.assetInfo['key'],this.assetInfo['route'],this.form.value)
       }
       
      } else{
        console.log('this.asset.info.route',this.assetInfo['route'])
        if(this.assetInfo['route'] === '/empresas/NETSOLINPRUEBA/assets'){
          const asset = this.form.value
          asset.model = asset.class.key
          this.cb.addDocSinIdFb(this.assetInfo['route'],asset)

        } else{

          this.cb.addDocSinIdFb(this.assetInfo['route'],this.form.value)
        }
       console.log('a grabar en', this.assetInfo)

     }
    this.close.emit(true);
   }
  }

  public clearForm(): void {
    // this.form.reset();
    this.close.emit(true);
  }
}